import Vue from "vue";

/**
 * RX COMMON ROUTER PAGE PATH CONST
 */
export default {
  // TODO: 스타일 관련 상수 등록

  /** 쿠폰 타입 */
  couponType: {
    GENERAL: {
      color: "#78909C", //blue-grey lighten-1
      icon: "mdi-ticket-percent",
    },
    BEARER: {
      color: "#42A5F5", //blue lighten-1
      icon: "mdi-incognito",
    },
    EVENT: {
      color: "secondary lighten-3",
      icon: "mdi-party-popper",
    },
    GRADE: {
      color: "#FFB300", //amber darken-1
      icon: "mdi-star",
    },
    MEMBER: {
      color: "#78c200ff", //amber darken-1
      icon: "mdi-account-star",
    },
    ALL: {
      color: "#18CED9", //primary
      icon: "mdi-ticket-confirmation",
    },
  },
  /** 쿠폰 혜택 타입 */
  benefitType: {
    SEAT: {
      color: "#AFB42B", //lime darken-2
      icon: "mdi-seat",
    },
    POINT: {
      color: "#AB47BC", //purple lighten-1
      icon: "mdi-alpha-p-circle",
    },
    DISCOUNT: {
      color: "#F57C00", //orange darken-2
      icon: "mdi-cash",
    },
    OTHER_PRODUCT: {
      color: "#303F9F", //indigo darken-2
      icon: "mdi-gift",
    },
    ENTER: {
      color: "#309f36ff", //indigo darken-2
      icon: "mdi-location-enter",
    },
    RAFFLE: {
      color: "#8a8a8aff", //indigo darken-2
      icon: "mdi-ticket-confirmation",
    },
    ALL: {
      color: "primary",
      icon: "mdi-ticket-confirmation",
    },
  },
  /** 쿠폰 상태 */
  couponStatus: {
    ISSUE: {
      color: "success",
    },
    CANCEL: {
      color: "error",
    },
    USED: {
      color: "primary",
    },
    EXPIRED_VALID: {
      color: "grey",
    },
    EXPIRED_TRANSFER: {
      color: "warning",
    },
    EXPIRED_HANDOVER: {
      color: "warning",
    },
    EXPIRED_WITHDRAW: {
      color: "#7c7c7cff",
    },
  },
  useSystem: {
    SEAT: {
      backgroundColor: "#d5b24bff"
    },
    MYCARD: {
      backgroundColor: "#bac42dff"
    },
    APP: {
      backgroundColor: "#4294e6ff"
    },
    CRM: {
      backgroundColor: "#b74db9ff"
    },
    ETC: {
      backgroundColor: "#6863d8ff"
    }
  },

};
Vue.prototype.RX_STYLE = getExtendsStyle();

function getExtendsStyle() {
  // 1. @/*/js/consts 폴더 하위 js 파일 가져오기
  const files = require.context(
    "@",
    true,
    /js\/consts\/[A-Za-z0-9-_,\s]+style-const.js$/i
  );
  // 2. RX_STYLE 가져오기
  // let mergedStyle = Object.assign({}, RX_STYLE);
  let mergedStyle = {};
  // 3. 추가 파일 RX_STYLE 머지
  files.keys().forEach((key) => {
    const extendsFiles = files(key).default;
    mergedStyle = Object.assign(mergedStyle, extendsFiles);
    // }
  });
  return mergedStyle;
}
